<template >
  <div v-if="showMessage" @contextmenu.prevent="openMenu($event, message)">
    <div v-if="!message.belong" class="text-body" style="display: flex; justify-content: space-between">
      <div style="display: flex">
        <div class="audio-text-my" style="margin-right: 10px">{{ message.messageAudioLength }}′′</div>
        <img class="image-box-audio" src="@/assets/audio.png" style="cursor: pointer; margin-right: 120px" @click="startplayAudio(message, message.id)" />
      </div>
      <img class="image-box-audio" style="cursor: pointer; width: 18px" src="@/assets/wenzi.png" @click="redAudio(message, message.id)" />
     
    </div>
    <div v-if="message.belong" class="text-body-my" style="display: flex; justify-content: space-between">
      <img class="image-box-audio" style="cursor: pointer; margin-right: 120px; width: 18px" src="@/assets/wenzi.png" @click="redAudio(message, message.id)" />
      <div style="display: flex">
        <img class="image-box-audio" src="@/assets/audio.png" style="cursor: pointer" @click="startplayAudio(message, message.id)" />
        <div class="audio-text-my">{{ message.messageAudioLength }}′′</div>
      </div>
    </div>
    <div class="csot" v-if="message.redfy">{{ message.messageMsg }}</div>
  </div>
</template>
  <script>
import BenzAMRRecorder from 'benz-amr-recorder'
import {Howl} from 'howler';

import KDXF from '@/Kdxf/kdxf'
export default {
  name: 'AudioMessage',
  components: {},
  props: {
    message: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      showMessage: false,
      armRec: null,
      audioPlayStatus: [],
    }
  },
  mounted() {
    this.showMessage = true
  },
  methods: {
    openMenu(event,item){
        console.log("右键事件最底层")
        this.$emit('openMenu',{event:event,item:item})
    },
    redAudio(item) {
      let that = this

      if (item.redfy == 1) {
        item.redfy = 0
        that.$forceUpdate()
        return
      }
      item.redfy = 1
      // if (item.redtext) {
      //   that.$forceUpdate()
      //   return
      // }
      // that.$forceUpdate()
      // KDXF.redfile(item.messageUrl, redtext => {
      //   item.redtext = redtext
      //   console.log(item)
      //   that.$forceUpdate()
      // })
      // console.log(item.redtext)
      item.redtext = item.messageMsg
      this.$forceUpdate()
    },
    startplayAudio(item, index) {
      console.log(this.audioPlayStatus)
      if (this.audioPlayStatus[index] == 1) {
        console.log('暂停')
        this.armRec.pause()
        this.audioPlayStatus[index] = 2
        return
      } else if (this.audioPlayStatus[index] == 2) {
        console.log('继续播放')
        this.armRec.play()
        this.audioPlayStatus[index] = 1
        return
      } else if (this.audioPlayStatus[index] == 0) {
        this.armRec.play()
        return
      } else {
        if (this.audioPlayStatus.length > 0) {
          console.log('播放多个先停止')
          this.armRec.stop()
          return
        }
      }

      //初始化音频源并调用播放
      this.armRec = new Howl({
        src:[item.messageUrl],
        format:['aac'],
        onloaderror:(e)=>{
          console.log(e)
        },
        onplay: () => {
         console.log('播放事件');
        },
        onpaste:()=>{
          this.audioPlayStatus[index] = 2
          console.log('暂停事件');
        },
        onstop:()=>{
          this.audioPlayStatus[index] = 0
          console.log('停止事件')
        },
        onend:()=>{
          this.audioPlayStatus = []
          console.log('结束事件')
        }
      })
      this.armRec.play()
      this.audioPlayStatus[index] = 1
    },
  },
}
</script>
  <style scoped>
.text-body {
  max-width: 100%;
  opacity: 1;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  font-weight: normal;
  line-height: 18px;
  letter-spacing: 0px;
  color: #222222;
  text-align: left;
  margin-left: 10px;
  border-radius: 0px 10px 10px 10px;
  padding: 10px;
  background: #eeeeee;
  margin-top: 6px;
}
.text-body-my {
  max-width: 100%;
  opacity: 1;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  font-weight: normal;
  line-height: 18px;
  letter-spacing: 0px;
  color: #222222;
  text-align: left;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 10px 0px 10px 10px;
  padding: 10px;
  background: #fff3e8;
  margin-top: 6px;
}
.text-body p {
  margin-bottom: 0px !important;
}
.text-body-my p {
  margin-bottom: 0px !important;
}
.image-box-audio {
  width: 14px;
  cursor: pointer;
}
.audio-text-my {
  font-family: PingFangSCRegular-Regular;
  font-size: 12px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #999999;
  margin-left: 8px;
}
.csot-my {
  margin-top: 10px;
  margin-right: 10px;
  max-width: 400px;
}
.csot {
  margin-top: 10px;
  margin-left: 10px;
  max-width: 400px;
}
</style>